import { atomWithStorage, createJSONStorage } from 'jotai/utils';

/**
 * Creates a Jotai atom persisted to sessionStorage.
 * State is isolated per-tab and persists on refresh within the same tab.
 */
export const atomWithSession = <T>(key: string, initialValue: T) =>
  atomWithStorage(
    key,
    initialValue,
    createJSONStorage(() => sessionStorage)
  );
